/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Book } from '../../models/book';

export interface FindBooks$Params {
  state?: 'ACTIVE' | 'INACTIVE';
}

export function findBooks(http: HttpClient, rootUrl: string, params?: FindBooks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Book>>> {
  const rb = new RequestBuilder(rootUrl, findBooks.PATH, 'get');
  if (params) {
    rb.query('state', params.state, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Book>>;
    })
  );
}

findBooks.PATH = '/api/books';
